<template>
  <div class="print-container">
    <el-card class="print-card1">
      <div class="main-header">
        <div class="main-header-left">
          <span>{{$t('Quick Print')}}</span>
        </div>
      </div>
      <hr class="small-hr">

      <div class="content1">
        <p>{{$t('Quick Print Settings')}}:</p>
        <hr class="spe-hr">
      </div>
      <div class="content2" style="margin-bottom: 15px;">
        <p>{{$t('Select duration')}}:&nbsp;</p>
        <select  v-model="timeInterval" @change="timeIntervalChange">
          <option>{{$t('One Week')}}</option>
          <option>{{$t('One Month')}}</option>
          <option>{{$t('One Quarter')}}</option>
        </select>
      </div>
      <div class="content2">
        <p  style="margin-bottom: 25px;">{{$t('End date')}}:</p>
        <select  v-model="endDate"  @change = "timeChange" class="cust">
          <option>{{$t('Yesterday')}}</option>
          <option v-show="time1">{{$t('Last Saturday')}}</option>
          <option v-show="time1">{{$t('Last Sunday')}}</option>
          <option v-show="time2">{{$t('Last Day of Last Month')}}</option>
          <option v-show="time3">{{$t('Last Day of Last Quarter')}}</option>
          <option>{{$t('Customize')}}</option>
        </select>
        <div v-show="cust" class="block cust">
          <el-date-picker  v-model="custTime" type="date"  :editable=false   :picker-options="pickerOptions" @change="customizeDate"
                          :clearable=false   :placeholder="custDate"    format="dd-MM-yyyy">
          </el-date-picker>
        </div>
        <p>{{$t('period')}}:&nbsp;&nbsp;<span>{{timeRange}}</span></p>
      </div>
      <div class="content1 custn">
        <p>{{$t('Week Filter')}}:</p>
        <hr class="spe-hr">
      </div>
      <div class="weeks" id="weeks">
        <span class="tittle"><label @click="chooseAll" >{{$t('Weekdays')}}</label></span>
        <span><label @click="choose" >{{$t('Mon')}}</label></span>
        <span><label @click="choose">{{$t('Tue')}}</label></span>
        <span><label @click="choose">{{$t('Wed')}}</label></span>
        <span><label @click="choose">{{$t('Thur')}}</label></span>
        <span><label @click="choose">{{$t('Fri')}}</label></span>
      </div>
      <div class="weeks weken" id='weken'>
        <span class="tittle" :class="{'de1':isDe,'it1':isIt,'po1':isPo,'du1':isDu,'fr1':isFr,'sw1':isSw,'cz5':isCz}"><label @click="chooseAll" >{{$t('Weekends')}}</label></span>
        <span  :class="{'zh3':!isEn}"><label @click="choose">{{$t('Sat')}}</label></span>
        <span class="spe-span" :class="{'zh4':!isEn,'it2':isIt,'po2':isPo,'du2':isDu,'fr2':isFr,'sw2':isSw,'cz2':isCz}"><label @click="choose">{{$t('Sun')}}</label></span>
      </div>
      <div class="content1">
        <p>{{$t('Select reports to print')}}:</p>
        <hr class="spe-hr">
      </div>

      <div class="report">
      <div class="content3">
        <label @click="chooseAll"></label><p>{{$t('All')}}</p>
        <hr class="spe-hr">
      </div>

      <div class="content3">
        <label @click="choose1" id="dash"></label>
        <p>{{$t('dashboard')}}</p>
        <div class="time" :class="{'zh1':!isEn}">
          <div class="block">
            <el-date-picker v-model="value12" type="date"  :editable=false    :picker-options="pickerOptions"
                            :clearable=false   :placeholder="defaultDate2"    format="dd-MM-yyyy">
            </el-date-picker>
          </div>
          <span class="to">{{$t('To')}}</span>
          <div class="block">
            <el-date-picker v-model="value11" type="date"  :editable=false    :picker-options="pickerOptions"
                            :clearable=false  :placeholder="defaultDate1"    format="dd-MM-yyyy">
            </el-date-picker>
          </div>
          <span>{{$t('From')}}</span>
        </div>
        <hr class="spe-hr">
      </div>

      <div class="content3">
        <label @click="choose1" id="ds"></label>
        <p>{{$t('Daily Summary')}}</p>
        <div class="time" :class="{'zh1':!isEn}">
          <div class="block">
            <el-date-picker v-model="value12" type="date"  :editable=false    :picker-options="pickerOptions"
                            :clearable=false   :placeholder="defaultDate2"    format="dd-MM-yyyy">
            </el-date-picker>
          </div>
          <span class="to">{{$t('To')}}</span>
          <div class="block">
            <el-date-picker v-model="value11" type="date"  :editable=false    :picker-options="pickerOptions"
                            :clearable=false  :placeholder="defaultDate1"    format="dd-MM-yyyy">
            </el-date-picker>
          </div>
          <span>{{$t('From')}}</span>
        </div>
        <hr class="spe-hr">
      </div>

      <div class="content3">
        <label @click="choose1" id="dd"></label>
        <p>{{$t('Day By Day Overview')}}</p>
        <div class="time"  :class="{'zh1':!isEn}">
          <div class="block">
            <el-date-picker v-model="value22" type="date"  :editable=false    :picker-options="pickerOptions"
                            :clearable=false   :placeholder="defaultDate2"    format="dd-MM-yyyy" >
            </el-date-picker>
          </div>
          <span class="to">{{$t('To')}}</span>
          <div class="block">
            <el-date-picker v-model="value21" type="date"  :editable=false    :picker-options="pickerOptions"
                            :clearable=false  :placeholder="defaultDate1"    format="dd-MM-yyyy">
            </el-date-picker>
          </div>
          <span>{{$t('From')}}</span>
        </div>
        <hr class="spe-hr">
      </div>
      <div class="content3">
        <label @click="choose1" id="ol"></label>
        <p>{{$t('Sensor Overlay')}}</p>
        <div class="time"  :class="{'zh1':!isEn}">
          <div class="block">
            <el-date-picker v-model="value32" type="date"  :editable=false    :picker-options="pickerOptions"
                            :clearable=false  :placeholder="defaultDate2"    format="dd-MM-yyyy" >
            </el-date-picker>
          </div>
          <span class="to">{{$t('To')}}</span>
          <div class="block">
            <el-date-picker v-model="value31" type="date"  :editable=false    :picker-options="pickerOptions"
                            :clearable=false :placeholder="defaultDate1"    format="dd-MM-yyyy">
            </el-date-picker>
          </div>
          <span>{{$t('From')}}</span>
        </div>
        <hr class="spe-hr">
      </div>
      <div class="content3">
        <label @click="choose1" id="ta"></label>
        <p>{{$t('Trend Analysis')}}</p>
        <div class="time"  :class="{'zh1':!isEn}">
          <div class="block">
            <el-date-picker v-model="value42" type="date"  :editable=false    :picker-options="pickerOptions"
                            :clearable=false   :placeholder="defaultDate2"    format="dd-MM-yyyy">
            </el-date-picker>
          </div>
          <span class="to">{{$t('To')}}</span>
          <div class="block">
            <el-date-picker v-model="value41" type="date"  :editable=false    :picker-options="pickerOptions"
                            :clearable=false  :placeholder="defaultDate1"    format="dd-MM-yyyy">
            </el-date-picker>
          </div>
          <span>{{$t('From')}}</span>
        </div>
        <hr class="spe-hr">
      </div>
      <div class="content3" v-show="!isM">
        <label @click="choose1" id="lg"></label>
        <p>{{$t('Logbook')}}</p>
        <div class="time"  :class="{'zh1':!isEn}">
          <div class="block">
            <el-date-picker v-model="value52" type="date"  :editable=false    :picker-options="pickerOptions"
                            :clearable=false   :placeholder="defaultDate2"    format="dd-MM-yyyy" >
            </el-date-picker>
          </div>
          <span class="to">{{$t('To')}}</span>
          <div class="block">
            <el-date-picker v-model="value51" type="date"  :editable=false    :picker-options="pickerOptions"
                            :clearable=false   :placeholder="defaultDate1"    format="dd-MM-yyyy">
            </el-date-picker>
          </div>
          <span>{{$t('From')}}</span>
        </div>
        <hr class="spe-hr">
      </div>
      <div class="content3" v-show="!isM">
        <label @click="choose1" id="ev"></label>
        <p>{{$t('Event Summary')}}</p>
        <div class="time"  :class="{'zh1':!isEn}">
          <div class="block">
            <el-date-picker v-model="value62" type="date"  :editable=false    :picker-options="pickerOptions"
                            :clearable=false   :placeholder="defaultDate2"    format="dd-MM-yyyy">
            </el-date-picker>
          </div>
          <span class="to">{{$t('To')}}</span>
          <div class="block">
            <el-date-picker v-model="value61" type="date"  :editable=false    :picker-options="pickerOptions"
                            :clearable=false    :placeholder="defaultDate1"    format="dd-MM-yyyy">
            </el-date-picker>
          </div>
          <span>{{$t('From')}}</span>
        </div>
        <select v-model="evType">
          <option selected>{{$t('date')}}</option><option>{{$t('item')}}</option>
        </select>
        <hr class="spe-hr">
      </div>

      <div class="content3">
        <label @click="choose1" id="alert"></label>
        <p>{{$t('Alert')}}</p>
        <div class="time" :class="{'zh1':!isEn}">
          <div class="block">
            <el-date-picker v-model="value12" type="date"  :editable=false    :picker-options="pickerOptions"
                            :clearable=false   :placeholder="defaultDate2"    format="dd-MM-yyyy">
            </el-date-picker>
          </div>
          <span class="to">{{$t('To')}}</span>
          <div class="block">
            <el-date-picker v-model="value11" type="date"  :editable=false    :picker-options="pickerOptions"
                            :clearable=false  :placeholder="defaultDate1"    format="dd-MM-yyyy">
            </el-date-picker>
          </div>
          <span>{{$t('From')}}</span>
        </div>
        <hr class="spe-hr">
      </div>

      <div class="content3" v-show="!isM">
        <label @click="choose1" id="dSet"></label>
        <p>{{$t('Device Settings Review')}}</p>
        <hr class="spe-hr">
      </div>
      </div>
      <button @click="print" :class="{'zh2':!isEn}">{{$t('createReport')}}</button>
    </el-card>
    <!--Add对话框-->
    <el-dialog  :visible.sync="typeChooseVisible" :size=dialogSize  id="dialog-form2" :show-close="false" >
      <div slot="title" class="patientList-dialog-title">
        <span>{{$t('setPeriod')}}</span>
        <img src="../assets/cancel.png" @click="cancel">
      </div>
      <div slot class="dialog-body">
        <div class="duration" >
          <span>{{$t('duration')}}</span>
          <select id="duration">
            <option>{{$t('7 days')}}</option>
            <option>{{$t('14 days')}}</option>
          </select>
        </div>
        </div>
        <hr class="patientList-small-hr">
      <div slot="footer" class="dialog-footer">
        <button  @click="cancel">{{$t('applyM')}}</button>
        <button  class="cancelButton" @click="cancel">{{$t('Cancel')}}</button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import * as echarts from 'echarts'
  import auth from '../auth/auth'
  import B64 from '../auth/base64'
  import format from '@/lib/format'
  export default{
    data(){
      return{
        value1:'',value2:'',defaultDate:'17-8-2017',count1:0,count:0,end:'',sta:'',st:'',et:'',defaultDate2:'17-8-2017',typeChooseVisible:false,dialogSize:'tiny',
        timeInterval:this.$t('One Week'),endDate:this.$t('Yesterday'), time1:true,time2:false,time3:false,timeRange:'',defaultDate1:'17-8-2017',
        cust:false,custTime:'',custDate:'',isM:false,isDe:false,isIt:false,isPo:false,isDu:false,isFr:false,isSw:false,isCz:false,
        pickerOptions:{
          disabledDate(time){
            return time.getTime()>Date.now()-8.64e7;
          }
        },
        weekmode:'yyyyyyyy',evType:this.$t('date'),
        value11:'',value12:'', qst1:'',qet1:'',
        value21:'',value22:'', qst2:'',qet2:'',
        value31:'',value32:'', qst3:'',qet3:'',
        value41:'',value42:'', value51:'',value52:'',value61:'',value62:'',isEn:false,
        isT1:true,isT2:true,isT3:true,isT4:true,isT5:true,isT6:true,

        uid:0, page:1,pages:5,has_next:'',has_prev:'',PDM:[],value71:'',value72:'',
      }
    },

    methods: {
      timeIntervalChange(){
        if(this.timeInterval===this.$t('One Week')){
          this.time1 = true;
          this.time2 = false;
          this.time3 = false;
        }
        if(this.timeInterval===this.$t('One Month')){
          this.time1 = false;
          this.time2 = true;
          this.time3 = false;
        }
        if(this.timeInterval===this.$t('One Quarter')){
          this.time1 = false;
          this.time2 = false;
          this.time3 = true;
        }
        this.endDate = this.$t('Yesterday');
        this.timeChange();
      },
      timeChange(){
        if(this.timeInterval===this.$t('One Week')&&this.endDate===this.$t('Yesterday')){
          this.end = new Date().setHours(0,0,0,0)/1000-86400;
          this.sta = this.end -86400*6;
        }
        if(this.timeInterval===this.$t('One Week')&&this.endDate===this.$t('Last Saturday')){
          let now = new Date().setHours(0,0,0,0);
          let currentDay = new Date(now).getDay();
          this.end = now/1000 - 86400*(currentDay+1);
          this.sta = this.sta = this.end -86400*6;
        }
        if(this.timeInterval===this.$t('One Week')&&this.endDate===this.$t('Last Sunday')){
          let now = new Date().setHours(0,0,0,0);
          let currentDay = new Date(now).getDay();
          this.end = now/1000 - 86400*currentDay;
          this.sta = this.sta = this.end -86400*6;
        }
        if(this.timeInterval===this.$t('One Month')&&this.endDate===this.$t('Yesterday')){
          this.end = new Date().setHours(0,0,0,0)/1000-86400;
          this.sta = this.end -86400*30;
        }
        if(this.timeInterval===this.$t('One Month')&&this.endDate===this.$t('Last Day of Last Month')){
          let now = new Date().setHours(0,0,0,0);
          let currentDay = new Date(now).getDate();
          this.end = now/1000 - 86400*currentDay;
          this.sta = this.end -86400*30;
        }
        if(this.timeInterval===this.$t('One Quarter')&&this.endDate===this.$t('Yesterday')){
          this.end = new Date().setHours(0,0,0,0)/1000-86400;
          this.sta = this.end -86400*30*3;
        }
        if(this.timeInterval===this.$t('One Quarter')&&this.endDate===this.$t('Last Day of Last Quarter')){
          let now = new Date().setHours(0,0,0,0);
          let end =  now/1000 -86400*30*3;
          let endDay = new Date(end*1000).getDate();
          this.end = end + 86400*(30-endDay);
          this.sta = this.end -86400*30*3;
        }
        if(this.endDate===this.$t('Customize')){
          this.cust = true;
          this.custTime ='';
          this.custDate = format.formatterDate4(new Date().setHours(0,0,0,0)/1000-86400);
          this.end = new Date().setHours(0,0,0,0)/1000-86400;
          if(this.timeInterval===this.$t('One Week')){
            this.sta = this.end -86400*6;
          }
          if(this.timeInterval===this.$t('One Month')){
            this.sta = this.end -86400*30;
          }
          if(this.timeInterval===this.$t('One Quarter')){
            this.sta = this.end -86400*30*3;
          }
        }else{
          this.cust = false;
        }
        this.timeRange = format.formatterDate2(this.sta)+' - '+format.formatterDate2(this.end);
        let day = (this.end-this.sta)/86400+1;
        this.defaultDate1 = format.formatterDate4(this.sta);
        this.defaultDate2 = format.formatterDate4(this.end);
      },
      customizeDate(){
        this.end = this.custTime.getTime()/1000;
        if(this.timeInterval===this.$t('One Week')){
          this.sta = this.end -86400*6;
        }
        if(this.timeInterval===this.$t('One Month')){
          this.sta = this.end -86400*30;
        }
        if(this.timeInterval===this.$t('One Quarter')){
          this.sta = this.end -86400*30*3;
        }
        this.timeRange = format.formatterDate2(this.sta)+' - '+format.formatterDate2(this.end);
        let day = (this.end-this.sta)/86400+1;
        this.defaultDate1 = format.formatterDate4(this.sta);
        this.defaultDate2 = format.formatterDate4(this.end);
      },
      choose(e){
        const parent = e.target.parentNode.parentNode;
        const labels =parent.getElementsByTagName('label');
        if(e.target.className===''){
          e.target.className = 'no';
          labels[0].className = 'no';
        }else{
          e.target.className = '';
          for(let i=1;i<labels.length;i++){
            if(labels[i].className===''){
              this.count++;}
          }
          if(this.count===labels.length-1){
            labels[0].className = '';
          }
          this.count = 0;
        }
      },
      choose1(e){
        const parent = e.target.parentNode.parentNode;
        const labels =parent.getElementsByTagName('label');
        if(e.target.className===''){
          e.target.className = 'no';
          labels[0].className = 'no';
        }else{
          e.target.className = '';
          for(let i=1;i<labels.length;i++){
            if(labels[i].className===''){
              this.count1++;}
          }
          if(this.count1===labels.length-1){
            labels[0].className = '';
          }
          this.count1 = 0;
        }
      },
      chooseAll(e){
        const parent = e.target.parentNode.parentNode;
        const labels =parent.getElementsByTagName('label');
        for(let i=0;i<labels.length;i++){
          if(this.flag===0){
            labels[i].className = 'no';
          }else{
            labels[i].className = '';
          }
        }
        if(labels[0].className==='no'){this.flag = 1;}
        else{ this.flag = 0;}
      },
      dateChange(){
        this.end = this.value1;
        if(this.end===''){
          //初始时，默认时间为昨天及之前七天
          this.sta = new Date().getTime()/1000;
          this.end = this.sta - 3600*24;
          this.sta = this.sta - 3600*24*8;
          this.sta = new Date(this.sta*1000);
        }else{
          this.end = new Date(this.end).getTime()/1000;
          this.sta = this.end - 3600*24*7;
          this.sta =new Date(this.sta*1000);
        }
        let y = this.sta.getFullYear();
        let m = this.sta.getMonth()+1;
        let d = this.sta.getDate();
        m = m<10 ? ('0'+m ): m;
        d = d<10 ? ('0'+d) : d;
        this.sta = d+'-'+m+'-'+y ;
        this.startDate = this.sta;
      },
      dateChange2(){
        let t = this.getTime(this.value71,this.value72);
        let qst = t[0];
        let qet = t[1];
        let param = {
          page:1,
          st:qst,
          et:qet,
          tz:parseInt(sessionStorage.getItem('tz')),
          flag:'web'
        };
       // console.log(param);
        auth.getPdm1(this,this.uid,param);
      },
      print(){
        let obj1 = document.getElementById('ds');
        let obj2 = document.getElementById('dd');
        let obj3 = document.getElementById('ol');
        let obj4 = document.getElementById('ta');
        let obj5 = document.getElementById('lg');
        let obj6 = document.getElementById('ev');
        let obj7 = document.getElementById('dSet');
        let obj8 = document.getElementById('dash');   // dashboard
        let obj9 = document.getElementById('alert');   // dashboard
        let report =[0,0,0,0,0,0,0,0,0,0,0];
        this.checkDate();

        // 新增的 Alert
        if (obj9.className!=='no') {
          let t1 = this.getTime(this.value11,this.value12);
          this.qst1 = t1[0];
          this.qet1 = t1[1];

          //if ()
          let dayNum1 = parseInt((this.qet1-this.qst1)/86400)+1;
          console.log('quick print:', dayNum1, this.qet1, this.qst1);
          report[10] = 1;    // 后面加的， 对应的打印的页面是 quickPrint10
          if(dayNum1>14) {
            this.isT1 = true;
            this.qst1=this.qet1-13*86400;
            sessionStorage.setItem('qst1',this.qst1);
            sessionStorage.setItem('qet1',this.qet1);

          } else if (dayNum1<1) {
            //this.isT1 = false;
            this.$message.error("Alert Report: date select wrong!");
            return;
          } else {
            this.isT1 = true;
            sessionStorage.setItem('qst1',this.qst1);
            sessionStorage.setItem('qet1',this.qet1);
            //window.open('/#/quickPrint1','_blank');
          }
        }

        // 新增的 dashboard
        if(obj8.className!=='no'){
          let t1 = this.getTime(this.value11,this.value12);
          this.qst1 = t1[0];
          this.qet1 = t1[1];
          let dayNum1 = parseInt((this.qet1-this.qst1)/86400)+1;
          report[9] = 1;    // 后面加的， 对应的打印的页面是 quickPrint9
          if(dayNum1>14) {
            this.isT1 = true;
            this.qst1=this.qet1-13*86400;
            sessionStorage.setItem('qst1',this.qst1);
            sessionStorage.setItem('qet1',this.qet1);

          }else if (dayNum1<1){
            //this.isT1 = false;
          }else{
            this.isT1 = true;
            sessionStorage.setItem('qst1',this.qst1);
            sessionStorage.setItem('qet1',this.qet1);
            //window.open('/#/quickPrint1','_blank');
          }
        }

        if(obj1.className!=='no'){
          let t1 = this.getTime(this.value11,this.value12);
          this.qst1 = t1[0];
          this.qet1 = t1[1];
          let dayNum1 = parseInt((this.qet1-this.qst1)/86400)+1;
          report[1] = 1;
          if(dayNum1>14) {
            this.isT1 = true;
            this.qst1=this.qet1-13*86400;
            sessionStorage.setItem('qst1',this.qst1);
            sessionStorage.setItem('qet1',this.qet1);

          }else if (dayNum1<1){
            //this.isT1 = false;
          }else{
            this.isT1 = true;
            sessionStorage.setItem('qst1',this.qst1);
            sessionStorage.setItem('qet1',this.qet1);
            //window.open('/#/quickPrint1','_blank');
          }
        }
        if(obj2.className!=='no'){
          let t2 =  this.getTime(this.value21,this.value22);
          this.qst2 = t2[0];
          this.qet2 =t2[1];
          let dayNum2 = parseInt((this.qet2-this.qst2)/86400)+1;
          report[2] = 1;
          if(dayNum2>14){
            this.isT2 = true;
            this.qst2 = this.qet2-13*86400;
            sessionStorage.setItem('qst2',this.qst2);
            sessionStorage.setItem('qet2',this.qet2);
          }else if (dayNum2<1){
            this.isT2 = false;
          }else{
            this.isT2 = true;
            sessionStorage.setItem('qst2',this.qst2);
            sessionStorage.setItem('qet2',this.qet2);
            // window.open('/#/quickPrint2','_blank');
          }
        }
        if(obj3.className!=='no'){
          let t3 =  this.getTime(this.value31,this.value32);
          this.qst3 = t3[0];
          this.qet3 =t3[1];
          let dayNum3 = parseInt((this.qet3-this.qst3)/86400)+1;
          report[3] = 1;
          if(dayNum3>7){
            this.isT3 = true;
            this.qst3=this.qet3-6*86400;
            sessionStorage.setItem('qst3',this.qst3);
            sessionStorage.setItem('qet3',this.qet3);
            sessionStorage.setItem('qweekMode',this.weekmode);

          }else if (dayNum3<1){
            this.isT3 = false;
          }else{
            this.isT3 = true;
            sessionStorage.setItem('qst3',this.qst3);
            sessionStorage.setItem('qet3',this.qet3);
            sessionStorage.setItem('qweekMode',this.weekmode);
            //window.open('/#/quickPrint1','_blank');
          }
        }
        if(obj4.className!=='no'){
          let t4 =  this.getTime(this.value41,this.value42);
          let qst4 = t4[0];
          let qet4 =t4[1];
          let dayNum4 = parseInt((qet4-qst4)/86400)+1;
          report[4] = 1;
          if(dayNum4>90){
            this.isT4 = true;
            this.qst4=this.qet4-89*86400;
            sessionStorage.setItem('qst4',qst4);
            sessionStorage.setItem('qet4',qet4);
            sessionStorage.setItem('qweekMode',this.weekmode);

          }else if (dayNum4<1){
            this.isT4 = false;
          }else{
            this.isT4 = true;
            sessionStorage.setItem('qst4',qst4);
            sessionStorage.setItem('qet4',qet4);
            sessionStorage.setItem('qweekMode',this.weekmode);
          }
        }
        if(obj5.className!=='no'&&!this.isM){
          let t5 =  this.getTime(this.value51,this.value52);
          let qst5 = t5[0];
          let qet5 =t5[1];
          let dayNum5 = parseInt((qet5-qst5)/86400)+1;
          report[5] = 1;
          if(dayNum5>14){
            this.isT5 = true;
            qst5=qet5-13*86400;
            sessionStorage.setItem('qst5',qst5);
            sessionStorage.setItem('qet5',qet5);
            sessionStorage.setItem('qweekMode',this.weekmode);

          }else if (dayNum5<1){
            this.isT5 = false;
          }else{
            this.isT5 = true;
            sessionStorage.setItem('qst5',qst5);
            sessionStorage.setItem('qet5',qet5);
            sessionStorage.setItem('qweekMode',this.weekmode);
          }
        }
        if(obj6.className!=='no'&&!this.isM){
          let t6 =  this.getTime(this.value61,this.value62);
          let qst6 = t6[0];
          let qet6 =t6[1];
          let dayNum6 = parseInt((qet6-qst6)/86400)+1;
          if(this.evType===this.$t('date')){
            report[6] = 1;
          }
          if(this.evType===this.$t('item')){
            report[7] = 1;
          }
          if(dayNum6>30){
            this.isT6 = true;
            qst6=qet6-29*86400;
            sessionStorage.setItem('qst6',qst6);
            sessionStorage.setItem('qet6',qet6);
          }else if (dayNum6<1){
            this.isT6 = false;
          }else{
            this.isT6 = true;
            sessionStorage.setItem('qst6',qst6);
            sessionStorage.setItem('qet6',qet6);
          }
        }
        if(obj7.className!=='no'&&!this.isM){
            if(this.PDM.length>0){
              report[8] = 1;
              let pdm = this.PDM[0][1]+','+this.PDM[0][2];
              let rid = this.PDM[0][0];
              sessionStorage.setItem('qPdm',pdm);
              sessionStorage.setItem('qRid',rid);
            }
        }
        report.map(function (e,i) {
          if(e===1){
            let key  = 'qFirst'+i;
            sessionStorage.setItem(key,1);
          }
        });
        sessionStorage.setItem('Reports',JSON.stringify(report));
        //console.log(report);
        if(this.checkDayNum()){
          for(let i=1;i<report.length;i++){
            if(report[i]===1){
              let path =  '/#/quickPrint'+i;
              console.log('quickReport:', path, i);
             let open = window.open(path,'_blank');
              if(open===null){
                this.$message.error('popup window intercepted');
              }
              break;
            }
          }
        }
      },
      getTime(t1,t2){
        let qst =0,qet=0;
        if(t1&&t2){
          qst = t1.getTime()/1000;
          qet = t2.getTime()/1000;
        }else if(t1){
          qst = t1.getTime()/1000;
          let ti = this.defaultDate2.split('-');
          qet = new Date(parseInt(ti[2]),parseInt(ti[1])-1,parseInt(ti[0])).getTime()/1000;
        }else if(t2){
          qet = t2.getTime()/1000;
          let ti = this.defaultDate1.split('-');
          qst = new Date(parseInt(ti[2]),parseInt(ti[1])-1,parseInt(ti[0])).getTime()/1000;
        }else{
          let ti = this.defaultDate1.split('-');
          qst = new Date(parseInt(ti[2]),parseInt(ti[1])-1,parseInt(ti[0])).getTime()/1000;
          let ti1 = this.defaultDate2.split('-');
          qet = new Date(parseInt(ti1[2]),parseInt(ti1[1])-1,parseInt(ti1[0])).getTime()/1000;
        }
        return [qst,qet];
      },
      checkDate(){
        const weeks = document.getElementById('weeks');
        const weken = document.getElementById('weken');
        if(weeks){
          const labels1 = weeks.getElementsByTagName('label');
          const labels2 = weken.getElementsByTagName('label');
          if(labels1[0].className===''&&labels2[0].className===''){this.weekmode='yyyyyyy';}
          else{
            this.weekmode='';
            for(let i=1;i< labels1.length;i++){
              if(labels1[i].className===''){
                this.weekmode +='y';
              }else{
                this.weekmode +='n';
              }
            }
            for(let i=1;i< labels2.length;i++){
              if(labels2[i].className===''){
                this.weekmode +='y';
              }else{
                this.weekmode +='n';
              }
            }
          }
        }
      },
      checkDayNum(){
        let dateTrue = true;
        let report = JSON.parse(sessionStorage.getItem('Reports'));
        //console.log(report)
        /*
        if(!this.isT1&& report[1]===1){
          this.$message.error('Daily Summary Reports Should Be 1-14 Days!');
          dateTrue =false;
        }
        if(!this.isT2&& report[2]===1){
          this.$message.error('Day By Day Overview Report Should Be 1-14 Days!');
          dateTrue =false;
        }
        if(!this.isT3&& report[3]===1){
          this.$message.error('Sensor Overlay Report Should Be 1-7 Days!');
          dateTrue =false;
        }
        if(!this.isT4&& report[4]===1){
          this.$message.error('Trend Analysis Report Should Be 1-90 Days!');
          dateTrue =false;
        }
        if(!this.isT5&& report[5]===1){
          this.$message.error('Logbook Report Should Be 1-14 Days!');
          dateTrue =false;
        }
        if(!this.isT6&& (report[6]===1||report[7]===1)){
          this.$message.error('Events Report Should Be 1-30 Days!');
          dateTrue =false;
        }*/
        return dateTrue;
      },
      getPdm1(){
        let param = {
          page:1,
          st:this.st,
          et:this.et,
          tz:parseInt(sessionStorage.getItem('tz')),
          flag:'web'
        };
        auth.getPdm1(this,this.uid,param);
      },
      apply(){},
      cancel(){
        this.typeChooseVisible=false;
      },
    },
    mounted(){
      let lang = sessionStorage.getItem('language');
      this.isEn = (lang!=='zh'&&lang !=='hk')?true:false;
      this.isDe = (lang==='de')?true:false;
      this.isIt = (lang==='it')?true:false;
      this.isPo = (lang==='po')?true:false;
      this.isDu = (lang==='du')?true:false;
      this.isFr = (lang==='fr')?true:false;
      this.isSw = (lang==='sw')?true:false;
      this.isCz = (lang==='cz')?true:false;
      this.isM = (sessionStorage.getItem('userType')==='M')?true:false;
      let win = window.innerWidth;
      this.dialogSize =(win<1500)?'small':'tiny';
      if(sessionStorage.getItem('userType')!=='P'){
        this.uid = parseInt(sessionStorage.getItem('patientId'));
      }else{
        this.uid = parseInt(sessionStorage.getItem('uid'));
      }
      this.et= new Date().setHours(0,0,0,0)/1000-86400;
      this.st = this.et-86400*6;
      this.getPdm1();
      this.defaultDate1 = format.formatterDate4(this.st);
      this.defaultDate2 = format.formatterDate4(this.et);
      this.timeChange();
    },

  }
</script>

<style scoped>
  .print-container{
    height:100%;
    width:100%;
    background:#fafbfc;
    font-size: 18px;
    color:#282828;
    letter-spacing:-0.44px;
    font-family:SFUIText-Regular;
    padding-top: 20px;
  }
  .print-card1{
    width: 97%;
    margin: 0 auto;
  }
  .print-card1 select{
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#282828;
    letter-spacing:-0.39px;
    background:#ffffff;
    border:1px solid #d2d2d2;
    border-radius:4px;
    padding-left: 10px;
  }
  .main-header{
    width:97%;
    height:30px;
    margin:0 auto;
  }
  .main-header-left{
    float: left;
    height:20px;
    line-height: 20px;
    margin-top:10px;
    border-left: 2px solid #005dac;
  }
  .main-header-left span{
    margin-left:10px;
  }
  .small-hr,.spe-hr{
    background:#e6e8ea;
    width:97%;
    height:1px;
    margin:10px auto 20px;
    border:none;
  }
  .spe-hr{
    width: 100%;
  }

  .content1,.content2,.content3{
    width:95%;
    margin:0 auto;
  }
  .content2{
    margin-bottom: 10px;
  }
  .content2 p{
    display: inline-block;
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#282828;
    letter-spacing:-0.43px;
    float: left;
  }
  .content2 select{
    width:150px;
    height:34px;
    margin:-4px 15px 0 8px;
    padding-left:2px;
  }
  .content2 .longSelect{
    width: 180px;
  }
  .content2 span{
    color:#0082d2;
  }

  .weeks{
    width:95%;
    margin:20px  auto;
  }
  .weken{
    margin-top: 20px;
    margin-bottom: 30px;
  }
  .weeks span{
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#6d6d6d;
    letter-spacing:-0.39px;
    text-align:left;
    margin-left: 4%;
  }
  .weken .spe-span{
    margin-left: 4.5%;
  }
  .weeks .zh3{
    margin-left: 5.5%;
  }
  .weeks .zh4{
    margin-left: 4%;
  }
  .weeks .tittle{
    margin: 0 2% 0 0;
    display: block;
    float: left;
    margin-bottom: 10px;
  }
  .weeks label{
    background: url("../assets/select yes.png") left 1px no-repeat;
    cursor: pointer;
    padding-left: 18px;
  }
  .weeks .no{
    background: url("../assets/select no.png") left 1px no-repeat;
  }
  .weeks .de1{
    margin-right: 8px;
  }
  .weeks .it1{
    margin-right: 0;
  }
  .weken .it2{
    margin-left: 3.9%;
  }
  .weeks .po1{
    margin-right: 12px;
  }
  .weeks .po2{
    margin-left: 3.9%;
  }
  .weeks .du1{
    margin-right: 41px;
  }
  .weeks .du2{
    margin-left: 4.1%;
  }
  .weeks .fr1{
    margin-right: 20px;
  }
  .weeks .fr2{
    margin-left:3.5%;
  }
  .weeks .sw1{
    margin-right: 36px;
  }
  .weeks .sw2{
    margin-left:4.7%;
  }

  .content3{
    height: 35px;
    margin-bottom: 18px;
    position: relative;
  }
  .content3 p{
    display: inline-block;
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#6d6d6d;
    letter-spacing:-0.39px;
    height: 20px;
    position: relative;
    bottom: 2px;
  }
  .content3 label{
    background: url("../assets/select yes.png") left 1px no-repeat;
    cursor: pointer;
    padding-left: 18px;
    margin-left: 10px;
    margin-right: 5px;
  }
  .content3 .no{
    background: url("../assets/select no.png") left 1px no-repeat;
  }
  .content3 select{
    width:130px;
    height:30px;
    float: right;
    margin-right: 3%;
    margin-top: -6px;
  }
  .content3 .spe-select{
    width:280px;
  }

  .time{
    float: right;
    margin-top: -10px;
  }
  .time span{
    display: block;
    float: right;
    margin-right: 20px;
    height:35px;
    line-height: 35px;
  }
  .zh1 span{
    font-size: 16px;
  }
  .time .to{
    margin:0 20px;
  }
  .time .block{
    float: right;
  }
  .el-date-editor.el-input{
    width:125px;
  }
  .cust{
    float: left;
    margin-top: -5px;
    margin-right: 10px;
  }
  .custn{
    clear: both;
  }
  .print-card1 button{
    background-image:linear-gradient(90deg, #42c3fd 0%, #55adf8 100%);
    box-shadow:0 3px 4px 0 #c6e1ff;
    color:#fff;
    margin: 80px 2% 20px 0;
    border-radius:100px;
    float: right;
    width:200px;
    height:30px;
    border:none;
    outline: none;
    cursor: pointer;
  }
  .print-card1 .zh2{
    font-size: 17px;
    width:150px;
  }
  .weeks .cz5{
    margin-right: 51px;
  }
  .weeks .cz2{
    margin-left: 4%;
  }
</style>



// WEBPACK FOOTER //
// print.vue?00c665fc